import { createNavigation } from 'next-intl/navigation';

import { routing } from 'src/i18n/routing';

const { usePathname } = createNavigation(routing);

export { usePathname };
